import { render, staticRenderFns } from "./edit_note.vue?vue&type=template&id=1aed624e"
import script from "./edit_note.vue?vue&type=script&lang=js"
export * from "./edit_note.vue?vue&type=script&lang=js"
import style0 from "./edit_note.vue?vue&type=style&index=0&id=1aed624e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports